import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_2 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-4 z-10 relative" }
const _hoisted_3 = { class: "flex justify-between items-center mb-4" }
const _hoisted_4 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_5 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_8 = { value: "text" }
const _hoisted_9 = { value: "number" }
const _hoisted_10 = { value: "date" }
const _hoisted_11 = { value: "email" }
const _hoisted_12 = { value: "phone" }
const _hoisted_13 = { value: "select" }
const _hoisted_14 = { value: "checkbox" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_17 = { class: "text-xs font-normal text-gray-500" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = {
  for: "required-field",
  class: "ml-2 text-sm text-gray-700 dark:text-gray-300"
}
const _hoisted_21 = { class: "flex justify-end gap-2 pt-2" }
const _hoisted_22 = {
  type: "submit",
  class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-all"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "fixed inset-0 bg-black opacity-50",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.isEditMode ? _ctx.directT('settings.leadsSettings.customFields.editField') : _ctx.directT('settings.leadsSettings.customFields.addField')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
              class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
            ]))
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveField && _ctx.saveField(...args)), ["prevent"])),
            class: "space-y-4"
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.fieldLabel')), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fieldData.label) = $event)),
                required: "",
                class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]",
                placeholder: _ctx.directT('settings.leadsSettings.customFields.fieldLabelPlaceholder'),
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.generateFieldKey && _ctx.generateFieldKey(...args)))
              }, null, 40, _hoisted_6), [
                [_vModelText, _ctx.fieldData.label]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.fieldType')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fieldData.type) = $event)),
                required: "",
                class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
              }, [
                _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.typeText')), 1),
                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.typeNumber')), 1),
                _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.typeDate')), 1),
                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.typeEmail')), 1),
                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.typePhone')), 1),
                _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.typeSelect')), 1),
                _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.typeCheckbox')), 1)
              ], 512), [
                [_vModelSelect, _ctx.fieldData.type]
              ])
            ]),
            (_ctx.fieldData.type === 'select')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.directT('settings.leadsSettings.customFields.dropdownOptions')) + " ", 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.onePerLine')), 1)
                  ]),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.optionsText) = $event)),
                    rows: "4",
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]",
                    placeholder: _ctx.directT('settings.leadsSettings.customFields.optionsPlaceholder')
                  }, null, 8, _hoisted_18), [
                    [_vModelText, _ctx.optionsText]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "required-field",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fieldData.required) = $event)),
                class: "w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500 dark:bg-[#15203c] dark:border-[#172036]"
              }, null, 512), [
                [_vModelCheckbox, _ctx.fieldData.required]
              ]),
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.requiredField')), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746]"
              }, _toDisplayString(_ctx.directT('settings.leadsSettings.delete.cancel')), 1),
              _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.directT('settings.leadsSettings.saveChanges')), 1)
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}